/* unplugin-vue-components disabled */import script from "./industry-kpi-search-page.vue?vue&type=script&setup=true&lang=js"
export * from "./industry-kpi-search-page.vue?vue&type=script&setup=true&lang=js"

import "./industry-kpi-search-page.vue?vue&type=style&index=0&id=4c772791&lang=postcss"

const __exports__ = script;

export default __exports__